import React from 'react'
import { useTranslation } from 'contexts/Localization'
import { getBridgeLink } from 'config/constants'
import { useWagmi } from 'libs/wagmi'
import QuestionHelper from 'components/QuestionHelper'

const NmxBridgeLink: React.FC = () => {
  const { t } = useTranslation()
  const { chainId } = useWagmi()

  return (
    <a className="flex items-center" href={getBridgeLink(chainId)} target="_blank" rel="noreferrer">
      <span className="text-primary hover:opacity-80 font-medium text-12">{t('NMX Bridge')}</span>

      <QuestionHelper
        content={t('Trading of NMX tokens is possible only in Binance Smart Chain network, please use the bridge.')}
        placement="right-start"
      />
    </a>
  )
}

export default NmxBridgeLink
